export const branchesInfo = {
  br: {
    cn: { name: "中文", head: "其他语言", url: "http://backrooms-wiki-cn.wikidot.com/", id: "4716348", category: "" },
    en: { name: "English", head: "Languages", url: "http://backrooms-wiki.wikidot.com/", id: "4431268", category: "" },
    es: {
      name: "Español",
      head: "En otros idiomas",
      url: "http://es-backrooms-wiki.wikidot.com/",
      id: "4745515",
      category: "",
    },
    fr: {
      name: "Français",
      head: "Dans d’autres langues",
      url: "http://fr-backrooms-wiki.wikidot.com/",
      id: "4710749",
      category: "",
    },
    de: {
      name: "Deutsch",
      head: "In anderen Sprachen",
      url: "http://dach-backrooms-wiki.wikidot.com/",
      id: "5054816",
      category: "",
    },
    id: {
      name: "Bahasa Indonesia",
      head: "Bahasa lainnya",
      url: "http://id-backrooms-wiki.wikidot.com/",
      id: "4760096",
      category: "",
    },
    it: {
      name: "Italiano",
      head: "In altre lingue",
      url: "https://it-backrooms-wiki.wikidot.com/",
      id: "4763243",
      category: "",
    },
    jp: {
      name: "日本語",
      head: "他言語版",
      url: "http://japan-backrooms-wiki.wikidot.com/",
      id: "4864894",
      category: "",
    },
    pl: {
      name: "Polski",
      head: "W innych językach",
      url: "http://pl-backrooms-wiki.wikidot.com/",
      id: "4761123",
      category: "",
    },
    ptbr: {
      name: "Português",
      head: "Em outros idiomas",
      url: "http://pt-br-backrooms-wiki.wikidot.com/",
      id: "4714912",
      category: "",
    },
    ru: {
      name: "Русский",
      head: "На других языках",
      url: "http://ru-backrooms-wiki.wikidot.com/",
      id: "4548260",
      category: "",
    },
    th: { name: "ภาษาไทย", head: "ภาษาอื่นๆ", url: "http://th-backrooms-wiki.wikidot.com/", id: "4911723", category: "" },
    vn: { name: "Tiếng Việt", head: "Ngôn ngữ", url: "http://backrooms-vn.wikidot.com/", id: "4748367", category: "" },
  },

  scp: {
    cn: { name: "中文", head: "其他语言", url: "https://scp-wiki-cn.wikidot.com/", id: "530812", category: "" },
    cs: { name: "Česky", head: "V jiných jazycích", url: "https://scp-cs.wikidot.com/", id: "2060442", category: "" },
    en: {
      name: "English",
      head: "In other languages",
      url: "https://scp-wiki.wikidot.com/",
      id: "66711",
      category: "",
    },
    fr: {
      name: "Français",
      head: "Dans d’autres langues",
      url: "https://fondationscp.wikidot.com/",
      id: "464696",
      category: "",
    },
    de: {
      name: "Deutsch",
      head: "In anderen Sprachen",
      url: "https://scp-wiki-de.wikidot.com/",
      id: "1269857",
      category: "",
    },
    id: {
      name: "Bahasa Indonesia",
      head: "Bahasa lainnya",
      url: "http://scp-id.wikidot.com/",
      id: "4416372",
      category: "",
    },
    int: { name: "International", head: "Languages", url: "https://scp-int.wikidot.com/", id: "1427610", category: "" },
    it: {
      name: "Italiano",
      head: "In altre lingue",
      url: "https://fondazionescp.wikidot.com/",
      id: "530167",
      category: "",
    },
    jp: { name: "日本語", head: "他言語版", url: "https://scp-jp.wikidot.com/", id: "578002", category: "" },
    ko: { name: "한국어", head: "다른 언어", url: "http://scpko.wikidot.com/", id: "486864", category: "" },
    pl: { name: "Polski", head: "W innych językach", url: "http://scp-pl.wikidot.com/", id: "647733", category: "" },
    ptbr: {
      name: "Português",
      head: "Em outros idiomas",
      url: "https://scp-pt-br.wikidot.com/",
      id: "783633",
      category: "",
    },
    ru: { name: "Русский", head: "На других языках", url: "http://scp-ru.wikidot.com/", id: "169125", category: "" },
    es: {
      name: "Español",
      head: "En otros idiomas",
      url: "http://lafundacionscp.wikidot.com/",
      id: "560484",
      category: "",
    },
    th: { name: "ภาษาไทย", head: "ภาษาอื่น", url: "https://scp-th.wikidot.com/", id: "547203", category: "" },
    ua: {
      name: "Українська",
      head: "Іншими мовами",
      url: "https://scp-ukrainian.wikidot.com/",
      id: "1398197",
      category: "",
    },
    vn: { name: "Tiếng Việt", head: "Ngôn ngữ", url: "https://scp-vn.wikidot.com/", id: "836589", category: "" },
  },
  
  wl: {
    cn: {
      name: "中文",
      head: "其他语言",
      url: "https://scp-wiki-cn.wikidot.com/",
      id: "530812",
      category: "wanderers:",
    },
    cs: {
      name: "Čeština",
      head: "V jiných jazycích",
      url: "https://wanderers-library-cs.wikidot.com/",
      id: "4600566",
      category: "",
    },
    en: {
      name: "English",
      head: "Languages",
      url: "https://wanderers-library.wikidot.com/",
      id: "146034",
      category: "",
    },
    fr: {
      name: "Français",
      head: "Dans d’autres langues",
      url: "https://fondationscp.wikidot.com/",
      id: "464696",
      category: "vagabonds:",
    },
    jp: {
      name: "日本語",
      head: "他言語版",
      url: "https://wanderers-library-jp.wikidot.com/",
      id: "4600658",
      category: "",
    },
    ko: {
      name: "한국어",
      head: "다른 언어",
      url: "https://wanderers-library-ko.wikidot.com/",
      id: "621849",
      category: "",
    },
    pl: {
      name: "Polski",
      head: "W innych językach",
      url: "https://wanderers-library-pl.wikidot.com/",
      id: "4593099",
      category: "",
    },
  },
} as const;
